import React from 'react';
import { useHistory } from 'react-router-dom';
import { object, string } from 'yup';
import { cloneDeep } from 'lodash';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from './FormResource.jsx';
import ListDesign from '../lists/ListDesigns.jsx';

const schema = object({
  orgId: string().matches(/^(?:\d+,?)+$/, 'Invalid Organization ID Format'),
});

const defaults = {
  name: '',
  designs: [],
  photos: [],
  description: '',
};

const FormCollaborators = ({ collaborator }) => {
  const history = useHistory();
  return (
    <FormResource
      {...{
        defaults,
        schema,
        stored: collaborator && {
          ...collaborator,
        },
        api: '/api/core/collaborators',
        onSubmit: (v) => {
          const form = cloneDeep(v);
          return form;
        },
      }}>
      <Tabs defaultActiveKey="basic" unmountOnExit>
        <Tab eventKey="basic" title="Basic">
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
          <div className="row">
            <div className="col">
              <FormGroup name="name" label="Collaborator" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup
                name="photos"
                as="slider"
                api="/api/core/collaborators/files"
                label="Photos"
                gridClassName="col-3 my-3"
                slideClassName="file-slide-contain square" />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup
                name="description"
                as="summernote"
                options={{
                  styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6'],
                  toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
                    ['view', ['codeview', 'undo', 'redo']],
                    ['para', ['paragraph']],
                  ],
                }} />
            </div>
          </div>
        </Tab>
        <Tab eventKey="designs" title="Designs">
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">Designed By</h6>
          <ListDesign
            filter={{
              collaborator: collaborator?._id || '000000000000000000000000',
            }}
            actions={{
              create: false,
              remove: false,
              fileImport: false,
            }}
            onRowClick={(row) => {
              history.push(
                `/admin/designs/items/${row._id}`,
              );
            } }
            fileImport={false}
            />
        </Tab>

      </Tabs>
    </FormResource>
  );
};

export default FormCollaborators;
